import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  // 지원할 언어 목록
  locales: ['ko', 'en'],
  
  // 기본 언어
  defaultLocale: 'ko',
  
  // locale prefix 전략
  // 'always': 항상 prefix 포함 (/en/about)
  // 'as-needed': 기본 언어는 prefix 없음 (/about), 다른 언어는 prefix 포함 (/en/about)
  // 'never': prefix 없음 (쿠키나 헤더로 언어 구분)
  localePrefix: 'as-needed',
});

